import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';

@Component({
    selector: 'app-book-info',
    templateUrl: './book-info.component.html',
    styleUrls: ['./book-info.component.scss'],
    standalone: true
})
export class BookInfoComponent {

    constructor(public applicationStateService: ApplicationStateService) {
    }
}
